import { useEffect, useState } from 'react';

import { openModal } from '@src/reduce/modals';
import { message, Switch } from 'antd';
import { useDispatch } from 'react-redux';

import useNavMenuKey from '@hooks/useNavMenuKey';
import { getFamilyEventSmsToggleStatus, toggleFamilyEventSms } from '@api/event';

import * as C from '@components/Common';
import NavMenu from '@components/NavMenu';
import Text from '@components/Text';

import type { NavMenuItems } from '@type/util';

import Table from './Table';
import type * as T from './type';

function FamilyEvent() {
  const dispatch = useDispatch();
  const [isSmsEnabled, setIsSmsEnabled] = useState<boolean>(true);
  const [isSmsToggleLoading, setIsSmsToggleLoading] = useState<boolean>(false);

  const navMenuItems: NavMenuItems<T.NavMenuType> = [{ key: 'list', label: '경조사 목록' }];

  const navMenuKey = useNavMenuKey<T.NavMenuType>(navMenuItems[0].key);

  const openCreateFamilyEventModal = () => {
    dispatch(openModal({ name: 'createFamilyEventModal' }));
  };

  const openDownloadFamilyEventModal = () => {
    dispatch(openModal({ name: 'downloadFamilyEventModal' }));
  };

  const onToggleSms = async (checked: boolean) => {
    setIsSmsToggleLoading(true);

    const response = await toggleFamilyEventSms({ data: { enabled: checked } });

    setIsSmsToggleLoading(false);
    if (!response) return;

    setIsSmsEnabled(response.enabled);
    message.success(`경조사 문자 발송이 ${response.enabled ? 'ON' : 'OFF'} 되었습니다.`);
  };

  useEffect(() => {
    const initializeSmsToggleStatus = async () => {
      setIsSmsToggleLoading(true);
      const response = await getFamilyEventSmsToggleStatus();
      setIsSmsToggleLoading(false);

      if (!response) return;
      setIsSmsEnabled(response.enabled);
    };

    initializeSmsToggleStatus();
  }, []);

  return (
    <C.Container>
      <C.Title>경조사관리</C.Title>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
        <Text size={12}>경조사 문자 발송</Text>
        <Switch checked={isSmsEnabled} loading={isSmsToggleLoading} onChange={onToggleSms} />
      </div>
      <NavMenu
        items={navMenuItems}
        defaultKey='list'
        rightButtons={[
          {
            text: '엑셀 다운로드',
            type: 'primary',
            onClick: openDownloadFamilyEventModal,
          },
          { text: '등록', type: 'primary', onClick: openCreateFamilyEventModal },
        ]}
      />
      {navMenuKey === 'list' && <Table />}
    </C.Container>
  );
}

export default FamilyEvent;
